import { render } from "./BlListField.vue?vue&type=template&id=57f6b989"
import script from "./BlListField.vue?vue&type=script&lang=js"
export * from "./BlListField.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/3a52593b-0c57-4976-8665-ec4c8a4d9b76/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__